import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { ErrorOutline } from '@mui/icons-material';

const IncompatibleFileFormatModal = ({
  open,
  onClose,
  title = 'Incompatible file format',
  okButtonText = 'Ok',
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        '.MuiDialog-paper': {
          width: '510px',
          boxShadow:
            '0px 8px 10px -5px rgba(0, 0, 0, 0.2),0px 16px 24px 2px rgba(0, 0, 0, 0.14),0px 6px 30px 5px rgba(0, 0, 0, 0.12)',
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          borderBottom: '1px solid rgba(0, 37, 71, 0.12)',
        }}
      >
        <ErrorOutline
          sx={{ color: 'rgba(211, 47, 47, 1)', width: '24px', height: '24px' }}
        />
        <div className='text-heading-style-1'>{title}</div>
      </DialogTitle>
      <DialogContent sx={{ padding: '20px 24px !important' }}>
        <div className='normal-text-style-2'>
          <p>SMART METRO doesn’t accept the file type you’ve chosen.</p>
          <p>Please use one of the following:</p>
          <p style={{ fontSize: '14px' }}>
            <strong>Tabular Data:</strong> .gdb, .geojson, .gpkg, .zip
          </p>
          <p style={{ marginTop: '-14px', fontSize: '14px' }}>
            <strong>Document Data:</strong> .docx, .html, .json, .pdf, .pptx, .txt,
            .xhtml, .xlsx, .xml
          </p>
        </div>
      </DialogContent>
      <DialogActions sx={{ padding: '16px 24px' }}>
        <Button
          variant='contained'
          onClick={onClose}
          className='error-contained-button-medium'
        >
          {okButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default IncompatibleFileFormatModal;
